import { Link } from "react-router-dom";
import { MapPin, Phone, Mail } from "lucide-react";
import { MEDIA } from "@/lib/media";

export default function Footer() {
  return (
    <footer className="relative bg-ink border-t border-white/10 pt-20 pb-10" data-testid="footer">
      <div className="max-w-[1500px] mx-auto px-6 md:px-10">
        <div className="grid md:grid-cols-3 gap-12 pb-16">
          <div>
            <div className="flex items-center gap-3 mb-6">
              <img src={MEDIA.logo} alt="Home Point Inspections" className="h-20 w-auto object-contain rounded-sm" />
            </div>
            <p className="text-cream/50 leading-relaxed max-w-xs">
              Meticulous, technology-driven home inspections for Georgia's finest homes. We see what others miss.
            </p>
          </div>

          <div>
            <h4 className="font-display uppercase tracking-[0.2em] text-gold text-xs mb-6">Explore</h4>
            <ul className="space-y-3 text-cream/60">
              <li><Link to="/" className="hover:text-gold transition-colors">Home</Link></li>
              <li><Link to="/book" className="hover:text-gold transition-colors">Book Inspection</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-display uppercase tracking-[0.2em] text-gold text-xs mb-6">Contact</h4>
            <ul className="space-y-4 text-cream/60">
              <li className="flex items-center gap-3"><MapPin size={18} className="text-gold" /> 6195 Crooked Creek Rd, Peachtree Corners 30092</li>
              <li className="flex items-center gap-3"><Phone size={18} className="text-gold" /> (404) 333-2989</li>
              <li className="flex items-center gap-3"><Mail size={18} className="text-gold" /> kadie@hpinspection.com</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-cream/40 text-sm">© {new Date().getFullYear()} Home Point Inspection, Inc. All rights reserved.</p>
          <p className="font-serif italic text-cream/40 text-sm">Serving Luxury Estates Across North Georgia</p>
        </div>
      </div>
    </footer>
  );
}
